import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { InputGroup, Button, Col, Row, Card, Accordion, Modal, Table, Spinner } from "react-bootstrap";
import { TextField, MenuItem, InputAdornment, IconButton } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ApiUserManager from "../../../core/api/api.userManager";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import DataGrid from "./DataGrid";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { numberRegex, tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SelectComponent from "../_Components/ReactSelectComponent";

export const UsersSite = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [status, setstatus] = useState([
    { id: 1, title: "تایید اعتبار" },
    { id: 2, title: "عدم تایید" },
  ]);
  // const [id,setId]=useState(false)
  const [show, setShow] = useState(false);
  const [dataForShow, setDataForShow] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        //دریافت لیست کاربران سایت
        const data = await ApiUserManager.getAllSiteUsers({
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          fromAmount: searchParams.get("fromAmount"),
          toAmount: searchParams.get("toAmount"),
          status: searchParams.get("status"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "status", type: "text" },
          { name: "fromAmount", type: "text" },
          { name: "toAmount", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (data.status)
      data.status = data.status.value == 1
    if (!_.isEmpty(data.fromAmount) && !validateNumber(data.fromAmount)) return;
    if (!_.isEmpty(data.toAmount) && !validateNumberToAmount(data.toAmount)) return;
    data.pageNumber = getValues("pageNumber");
    tools.setPageNumber(data, searchParams, setValue);

    data.fromAmount =
      data.fromAmount && data.fromAmount.length > 0
        ? data.fromAmount.replaceAll(" ", "").replaceAll(",", "")
        : undefined;
    data.toAmount =
      data.toAmount && data.toAmount.length > 0 ? data.toAmount.replaceAll(" ", "").replaceAll(",", "") : undefined;
    // data.phoneNumberConfirmed = data.status;
    //const apiData = await ApiUserManager.getAllSiteUsers({ pageSize: data.pageSize, pageNumber: getValues("pageNumber"), globalSearch: data.globalSearch });
    const apiData = await ApiUserManager.getAllSiteUsers(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount", "phoneNumberConfirmed"]),
    );
    navigate(`/usersSite?${queryString}`);
  };

  const callBack = (index) => {
    setShow(true);
    setDataForShow(index);
  };
  const handelCloseModal = () => {
    setShow(false);
  };
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("fromAmount", { type: "manual", message: "عدد وارد شده باید کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("fromAmount");
      return true;
    }
  };

  const validateNumberToAmount = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("toAmount", { type: "manual", message: "عدد وارد شده باید کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("toAmount");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت کاربران سایت</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست کاربران سایت</span>
          </h3>
          <div className="card-toolbar"></div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="از مبلغ"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  //prefix=" تومان "
                                  error={!!errors.fromAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumber(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.fromAmount && (
                              <div className="text-small-1 text-danger"> {errors.fromAmount.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toAmount"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="تا مبلغ"
                                  size="small"
                                  margin="normal"
                                  type="search"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  decimalScale="0"
                                  error={!!errors.toAmount}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberToAmount(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.toAmount && (
                              <div className="text-small-1 text-danger"> {errors.toAmount.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="status"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={status?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  placeholder="وضعیت"
                                  field={field}
                                  className="mt-5"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="شماره موبایل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={(e) => {
                                    if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                                      e.target.value = getValues("phoneNumber")
                                      return
                                    }
                                    onChange(e)
                                  }}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid data={listData} callBack={callBack} />
              </Col>
            </form>
          </FormProvider>
        </div>
        {/* ====================================================================================================== */}
        {/*  start modal for show details of singel data ,default is hide  */}
        <Modal centered size="lg" show={show} onHide={handelCloseModal}>
          <Modal.Header closeButton className="d-flex align-items-center justify-content-between">
            <Modal.Title>نمایش اطلاعات </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام</div>
                <div className="mt-2">{dataForShow.firstName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام خانوادگی </div>
                <div className="mt-2">{dataForShow.lastName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">نام کاربری </div>
                <div className="mt-2">{dataForShow.userName}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">ایمیل</div>
                <div className="mt-2">{dataForShow.email}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">شماره تماس </div>
                <div className="mt-2">{dataForShow.phoneNumber}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">موجودی کیف پول </div>
                <div className="mt-2">
                  {dataForShow.walletRiallBalance} <small>تومان</small>
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">تایید ایمیل </div>
                <div className="mt-2">{dataForShow.emailConfirmed ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">تایید تلفن همراه </div>
                <div className="mt-2"> {dataForShow.phoneNumberConfirmed ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">وضعیت</div>
                <div className="mt-2">{dataForShow.active ? "فعال" : "غیر فعال"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">اخرین ورود </div>
                <div className="mt-2">{dataForShow.lastLoginDate}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className=" text-muted fw-bold">زمان ایجاد </div>
                <div className="mt-2">{dataForShow.createdPersianTime} </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" type="button" onClick={handelCloseModal}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
        {/* end modal */}
        {/* ================================================================================================================ */}
      </div>
    </div>
  );
};
